export const BOOLEAN_SELECT = [
  { label: 'Да', value: 'true' },
  { label: 'Нет', value: 'false' },
];
